import { createAsyncThunk } from '@reduxjs/toolkit';

import type { InoGatewayResponse } from '@/Module/Core/Model/ApiModel';
import type { IFAQ } from '@/Module/Question/Model';
import FAQService from '@/Module/Question/Service/FAQService';
import type { IState } from '@/Module/Store/Model';

export const getFAQListByTypeIdAction = createAsyncThunk<InoGatewayResponse<IFAQ[]>>(
  'question/FAQGetType',
  async (_, { signal, getState }) => {
    return FAQService.getFAQ(
      {
        PageSize: (getState() as IState).faq.pageRows,
        Page: (getState() as IState).faq.page,
        SortDesc: true,
        CategoryId: (getState() as IState).faq.typeId || 1,
      },
      signal,
    ).then(({ data }) => data);
  },
);
